import React from "react"
import Navbar from "./Navbar"
import Body from "./Body"
import Footer from "./Footer"



export default function App() {


    return(
        <div>
            <Navbar />
            <Body />
            <Footer />
        </div>
    )
    

}